module.exports = __webpack_public_path__ + "media/images/flags/bi-c6a1308d05278463870931fc865c8c7c.svg";